import React, { useEffect, useState, useRef } from 'react';

interface StatsCounterProps {
  value: number;
  formatter?: (value: number) => string;
  className?: string;
}

export default function StatsCounter({ 
  value, 
  formatter = (val) => val.toLocaleString(), 
  className
}: StatsCounterProps) {
  const [displayValue, setDisplayValue] = useState(value);
  const previousValueRef = useRef(value);
  
  useEffect(() => {
    // 값이 변경되었을 때만 애니메이션 적용
    if (value !== previousValueRef.current) {
      const startValue = previousValueRef.current;
      const endValue = value;
      const duration = 1000; // 애니메이션 기간 (1초)
      const stepTime = 50; // 각 스텝 사이의 시간 (ms)
      const totalSteps = duration / stepTime;
      const increment = (endValue - startValue) / totalSteps;
      
      let currentStep = 0;
      let currentValue = startValue;
      
      const timer = setInterval(() => {
        currentStep++;
        currentValue += increment;
        
        if (currentStep >= totalSteps) {
          clearInterval(timer);
          setDisplayValue(endValue);
        } else {
          setDisplayValue(Math.round(currentValue));
        }
      }, stepTime);
      
      previousValueRef.current = value;
      
      return () => clearInterval(timer);
    }
  }, [value]);
  
  return (
    <span className={className}>
      {formatter(displayValue)}
    </span>
  );
}
